import React, {useState} from 'react';
import './css/video-container.css';
import PropTypes from "prop-types";

function VideoContainer({video, removeVideoById}) {
    const [isVisibleDeleteBtn, setVisible] = useState(false);

    const setVisibleDeleteBtn = () => setVisible(true);
    const setInvisibleDeleteBtn = () => setVisible(false);
    const removeVideo = () => removeVideoById({id: video.id});

    return (
        <div className={'video-container-with-btn'}>
            <video className="video-container" onMouseOut={setInvisibleDeleteBtn} onMouseOver={setVisibleDeleteBtn} controls>
                <source src={video.src} type="video/mp4"/>
            </video>
            <button className={`delete-btn ${isVisibleDeleteBtn? 'visible': ''}`}
                    onMouseOver={setVisibleDeleteBtn} onClick={removeVideo}>Delete</button>
            {video.status === "pending_approve" && <div className={`in-review`}>In review</div>}
        </div>
    );
}

VideoContainer.propTypes = {
    video: PropTypes.object,
    removeVideoById: PropTypes.func,
};

export default VideoContainer;
